import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { Tooltip } from '@/components/Tooltip';
import { Container } from '@/components/ui';
import { cn } from '@/utils/classname';

export interface MSRPCalculatorDisplayProps {
  msrp: number;
  breakdown: {
    platformFee: number;
    fqdnCost: number;
    assetCost: number;
    supportTier: number;
  };
  className?: string;
  title?: string;
  tooltipText?: string;
}

/**
 * MSRPCalculatorDisplay - Reusable component for displaying MSRP calculation with breakdown
 * Extracted from configure/index.tsx for use in both settings and wizard
 */
export const MSRPCalculatorDisplay: React.FC<MSRPCalculatorDisplayProps> = ({
  msrp,
  breakdown,
  className,
  title = 'MSRP Price',
  tooltipText = 'Auto-Calculated Based on Coverage Limits',
}) => {
  return (
    <section className={cn('space-y-4', className)}>
      <h3 className="text-chariot-text-primary text-lg font-semibold">
        {title}
      </h3>
      <Container className="bg-chariot-background-primary">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-chariot-text-primary mb-2 flex items-center gap-2 text-sm font-medium">
              {title}
              {tooltipText && (
                <Tooltip title={tooltipText}>
                  <InformationCircleIcon className="text-chariot-text-secondary h-4 w-4" />
                </Tooltip>
              )}
            </h2>
            {breakdown && (
              <div className="text-chariot-text-secondary mt-3 text-xs">
                Platform Fee: ${breakdown.platformFee.toLocaleString()},
                Application Scanning: ${breakdown.fqdnCost.toLocaleString()},
                Asset Coverage: ${breakdown.assetCost.toLocaleString()}, Support
                Tier: ${breakdown.supportTier.toLocaleString()}
              </div>
            )}
          </div>
          <div className="text-chariot-text-primary text-right text-2xl font-bold">
            ${msrp.toLocaleString()}
          </div>
        </div>
      </Container>
    </section>
  );
};
